import { render, staticRenderFns } from "./DropdownIconButton.vue?vue&type=template&id=764b2a5d&"
import script from "./DropdownIconButton.vue?vue&type=script&lang=js&"
export * from "./DropdownIconButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports